function getIPAddress() {
  fetch("https://ipinfo.io/json")
    .then((response) => response.json())
    .then((data) => {
      const country = data.country;
      let redirectURL = '';

      switch (country) {
        case 'AU':
          redirectURL = '/en-au';
          break;
        case 'US':
          redirectURL = '/en-us';
          break;
        case 'NZ':
          redirectURL = '/';
          break;
        default:
          redirectURL = '/en-int';
      }

      const currentPath = window.location.pathname;

      // Check if the user is already on the correct URL
      if (!isCorrectURL(currentPath, redirectURL)) {
        // Display modal before redirecting
        // showModal(country, redirectURL);
        // console.log(country);
        console.log(redirectURL)
      }
    })
    .catch((error) => console.error("Error fetching IP address:", error));
}

function isCorrectURL(currentPath, redirectURL) {
  const urlMap = {
    '/': ['/'],
    '/en-au': ['/en-au'],
    '/en-us': ['/en-us'],
    '/en-int': ['/en-int']
  };

  // Check if the current path matches any of the correct paths
  for (const key in urlMap) {
    if (urlMap[key].includes(currentPath) && key === redirectURL) {
      return true;
    }
  }
  return false;
}

function showModal(country, redirectURL) {
  const modal = document.createElement('div');
  modal.id = 'redirect-modal';
  modal.style.position = 'fixed';
  modal.style.top = '0';
  modal.style.left = '0';
  modal.style.width = '100%';
  modal.style.height = '100%';
  modal.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
  modal.style.display = 'flex';
  modal.style.justifyContent = 'center';
  modal.style.alignItems = 'center';
  modal.style.zIndex = '1000';

  const modalContent = document.createElement('div');
  modalContent.style.backgroundColor = '#fff';
  modalContent.style.padding = '20px';
  modalContent.style.borderRadius = '5px';
  modalContent.innerHTML = `<p>You will be redirected to the appropriate version of the site based on your location (${country}).</p>`;

  // modal.appendChild(modalContent);
  // document.body.appendChild(modal);

  // Redirect after 3 seconds
  setTimeout(() => {
    // window.location.replace(redirectURL);
  }, 3000);
}

window.onload = getIPAddress;
